import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination } from "swiper/modules";

import Media_Card from "../ui/media-card/media-card";
import SwiperPagination from "../ui/swiper/swiper-pagination";
import { MEDIA_BASE_URL } from "@/utils/api";

const Blog_Slider = ({ data }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  const blogList = data?.length >= 5 ? data.slice(0, 5) : data;

  return (
    <div className="Blog_Slider mb-10 border-b border-[#ccc]">
      <h3 className="text-black font-secondary text-[20px] lg:text-[1.5vw] uppercase mb-5 lg:mb-[1.5vw]">
        Top Blog
      </h3>

      {/* <Swiper
        slidesPerView={1}
        spaceBetween={10}
        speed={2000}
        loop={true}
        pagination={{
          clickable: true,
          el: ".explore-pagination",
        }}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[Pagination]}
        className="h-full"
      >
        {data.map((item, i) => (
          <SwiperSlide key={i} className="h-full">
            <div key={i}>
              <Media_Card
                imgSrc={`${mediaBaseUrl}${item.banner}`}
                title={item.title} 
                link={
                  {
                    pathname: "/blog-details",
                    query: {
                      slug : item.slug
                    },
                  }
                }
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper> */}

      {/* <SwiperPagination customClass={"explore-pagination !mt-0"} /> */}

      {blogList?.map((item, i) => (
        <div key={i} className="mb-5">
          <div key={i}>
            <Media_Card
              imgSrc={`${mediaBaseUrl}${item.banner}`}
              title={item.title}
              slug={item.slug}
              link={{
                pathname: `/blog/${item.slug}`,
                // query: {
                //   slug: item.slug,
                // },
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Blog_Slider;
